import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';

const IAEmptyLibraryNote: React.FC = () => (
  <Stack
    alignItems={'center'}
    spacing={1}
    sx={{
      bgcolor: 'background.paper',
      border: '1px dashed',
      borderColor: 'primary.tableBorder',
      borderRadius: 2,
      px: 3,
      py: 5,
      textAlign: 'center',
    }}
  >
    <AutoStoriesOutlinedIcon
      sx={{ color: 'text.secondary', fontSize: 34 }}
    />
    <Typography sx={{ fontSize: 16, fontWeight: 700 }}>
      {"Тут з'являться твої списки"}
    </Typography>
    <Box sx={{ maxWidth: 360 }}>
      <Typography sx={{ color: 'text.secondary', fontSize: 13.5 }}>
        {
          'Встав текст або файл вище — і кожен опрацьований матеріал збережеться сюди.'
        }
      </Typography>
    </Box>
  </Stack>
);

export default IAEmptyLibraryNote;
